import { 
    GET_SETTINGS_SUCCESS,
    UPDATE_SETTINGS_QUESTION_ANSWERS_SUCCESS,
    CHANGE_FEEDBACK_SUCCESS
} from './constants';

import {
    CREATE_THEME_IN_QUIZ_SUCCESS,
    UPDATE_THEME_IN_QUIZ_SUCCESS,
    DELETE_THEME_IN_QUIZ_SUCCESS,
} from '../../appearance/constants';

import {
    GET_FONTS_LIST_IN_QUIZ_SUCCESS,
    STORE_FONT_IN_QUIZ_SUCCESS
} from '../../../data/fonts/constants';

const initialPlayersState = [];
const editorState = {
    showFeedback: false
};

/**
 *
 * @param state
 * @param action
 * @returns {(Array&{fonts: *})|(Array&{appearance: *[]})|Array|(Array&{appearance: null})|(Array&{appearance: ...*[]})}
 */
const settingsReducer = (state = initialPlayersState, action) => {
    switch(action.type) {
        case GET_SETTINGS_SUCCESS:
            return {...state, ...action.settings};

        case UPDATE_SETTINGS_QUESTION_ANSWERS_SUCCESS:
            return {...state, ...action.value};
        case CREATE_THEME_IN_QUIZ_SUCCESS: {
            const appearance = [ ...state.appearance, action.theme ];
            return {...state, appearance: appearance};
        }

        case DELETE_THEME_IN_QUIZ_SUCCESS: {

            const selectedThemeID = state.appearance.find( theme => theme.selected).id;
            let themeIndex;
            if(selectedThemeID !== action.deletedID) {
                themeIndex = action.themes.indexOf(action.themes.find( theme => theme.id === selectedThemeID));
                action.themes[themeIndex].selected = true;
            } else {
                action.themes[0].selected = true;
            }

            return {...state, appearance: action.themes};
        }
        case UPDATE_THEME_IN_QUIZ_SUCCESS: {
            const themeIndex = state.appearance.indexOf(state.appearance.find( theme => theme.id === action.theme.id));
            let appearances = state.appearance;
            if(appearances[themeIndex].selected) {
                action.theme.selected = true;
            }
            appearances[themeIndex] = action.theme;
            return { ...state, appearance: [ ...appearances] };
        }
        case STORE_FONT_IN_QUIZ_SUCCESS: {
            return { ...state, fonts: action.fonts };
        }
        case GET_FONTS_LIST_IN_QUIZ_SUCCESS: {
            return { ...state, fonts: action.fonts };
        }
        default:
            return state;
        }
};

/**
 *
 * @param state
 * @param action
 * @returns {({showFeedback})|{showFeedback: boolean}}
 */
const editorReducer = (state = editorState , action) => {
    switch(action.type) {
        case CHANGE_FEEDBACK_SUCCESS: {
        let feedbackVal = {
            showFeedback: !state.showFeedback
        };
            return {...state, ...feedbackVal};
        }

        default:
            return state;
    }

};

export { settingsReducer as settings, editorReducer as editor};